export default __webpack_public_path__ + "static/072-79485aae101006c9d91889f7610807a2.jpg";